import { Routes, Route } from "react-router-dom";
import Layout from "../Components/Layout/Layout";
import Home from "../Pages/Home";
import ListingDetails from "../Pages/ListingDetails";



const Routing = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/listing" element={<ListingDetails />} />
      </Route>
    </Routes>
  );
};

export default Routing;
